import { JsonObject, JsonProperty, JsonType } from "ta-json";

import { type IQueryLoadConfiguration, QueryLoadConfiguration } from "../contracts/querying/query-load-configuration";

@JsonObject()
export class QueryLoadingResource {
    /**
     *  Indicates if and how entities resulting entities should be loaded. By default, no entities will be loaded, only ids.
     *
     *  @deprecated For backwards compatibility only. Loading configurations are now passed as a separate parameter.
     */
    @JsonProperty("load_configuration")
    @JsonType(QueryLoadConfiguration)
    loadConfiguration: IQueryLoadConfiguration = QueryLoadConfiguration.Ids;
}
